import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LoginService } from '../login.service';
import { PatientsService } from '../patients.service';
import { Patient } from './patient';
import { ExamsService } from '../exams.service';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GastroFormsService } from '../gastro-forms.service';
import { GastroService } from '../gastro.service';
import * as XLSX from 'xlsx';
import { writeFile } from 'xlsx';
import { HttpClient } from '@angular/common/http';
import { SearchParams, AddPatientParams } from '../patients-sidebar/patients-sidebar.component';
import { PatientsSidebarService } from '../patients-sidebar/patients-sidebar.service';
import { SPINNER_FADEOUT_DURATION } from '../app.constants';
import { pageCount, resolveTotal, shouldShowControls } from '../pagination';

@Component({
  selector: 'app-patients',
  templateUrl: './patients.component.html',
  styleUrls: ['./patients.component.scss'],
  standalone: false,
})
export class PatientsComponent implements OnInit, OnDestroy {
  @ViewChild('swipeField') swipeField: ElementRef;
  showIcons = false;
  showprintopts = false;
  showprint = false;
  inform = false;
  activeView: string | null = null;
  id: string;
  first: string;
  last: string;
  phone: string;
  showhelp = false;
  selectedPatient: Patient;
  formSelected: any;
  patList: Patient[];
  // Bumped on each search so a stale async response can't overwrite a newer view.
  private searchSeq = 0;
  // Per-view spinner flags, driven around each async fetch.
  awlListLoading = false;
  patListLoading = false;
  examListLoading = false;
  // Set for the fade window just before the matching *Loading flag clears, so the spinner fades
  // out instead of popping away. Mirrors dev's searchFading / examListFading.
  awlListFading = false;
  patListFading = false;
  examListFading = false;
  // True while the Patients view is active, so its title shows on entry, pre-results.
  patientSearchView = false;
  isAWL = false;
  AWLStatus = 'Waiting';
  AWLExam = 'All';
  AWLlist: Patient[];
  examList;
  patientsearch = true;
  fromd: Date;
  tod: Date;
  openEsearch = false;
  isReports = false;
  hmostype;
  exams;
  typeForm;
  examMode = 'All';
  examNames = [
    '1st',
    'NT',
    'Early',
    '2nd/3rd',
    'Late',
    'Third Scan',
    'Specialized',
    'Fetal Echo',
    'Gynecology',
    'Weight Assessment',
    'Tech Exam',
    'Emergency Room',
    'Amniocentesis',
    'CVS',
    'Follicles',
  ];
  examNamesGastro = ['Gastroscopy', 'Colonoscopy', 'Sigmoidoscopy'];
  cardioTodayListExams = [
    'אקו',
    'אקו לב',
    'אקו מכבי',
    'אקו לאומית',
    'אקו מאוחדת',
    'אקו לב במאמץ',
    'אקו במאמץ מכבי',
    'אקו במאמץ לאומית',
    'אקו במאמץ מאוחדת',
    'אקו במאמץ פרטי',
    'ארגומטריה',
    'ארגומטריה מכבי',
    'ארגומטריה לאומית',
    'ארגומטריה מאוחדת',
    'הולטר קצב לב',
    'בדיקת אקג',
    'קרוטיד US עורקי צואר',
    'ייעוץ קרדיולוגי',
    'יעוץ רפואי מכבי',
    'יעוץ רפואי לאומית',
    'יעוץ רפואי מאוחדת',
    'יעוץ רפואי כללית מושלם',
  ];
  reportsNames = ['statisticsForLeumit', 'missingPrn', 'sentToLeumit'];
  examVals = {};
  chosenAWL: number;
  awlTime: string;
  awlExamType: string;
  awlLMP;
  awlComment: string;
  prn: string;
  code: string;
  swiping = false;
  card: string;
  idcode: string;
  carderror: string;
  expcode: string;
  GA;
  GaArray: any[] = [];
  patExams: any[] = [];
  visitPat: any[] = [];
  showpayment: string;
  cardtzsearch: string;
  goEx = { preg: null, exam: null, etype: null };
  showLogin = false;
  startClinic: number;
  private destroy$ = new Subject();
  sub = new Subscription();
  startdate;
  enddate;
  changedExamCode;
  reportName = null;
  sentMacabi = false;
  concentForm;
  showConsentModal = false;
  consentModalPat = null;
  consentExamType = '';
  selectedGynConsentType = '';
  clinicPractitioners = [];
  consentPractitionerObj = null;
  showGynConsent = false;
  signatureSubscription = new Subscription();
  patConsentSigned: Record<number, boolean> = {};
  patQuestionnaireAnswered: { [awlid: number]: boolean } = {};
  showSendQuestionnaire = false;
  sendQuestionnairePatient: any = null;
  last_search_time;
  toreassign;
  show_surrogate = false;
  reportList = null;
  statisticsForDoctors = null;
  examTypeCounts: Record<string, number> = {};
  reportType: string;
  withoutPrn = false;
  currentPage = 1;
  pageSize = 25;
  showPaginationControls = false;
  // Server-reported match count, so the pager can show a real range instead of guessing from page length.
  totalResults = 0;
  get totalPages(): number {
    return pageCount(this.totalResults, this.pageSize);
  }
  // Exam search pagination, server-side like the patient search above.
  examPage = 1;
  examPageSize = 25;
  examTotal = 0;
  showExamControls = false;
  get examTotalPages(): number {
    return pageCount(this.examTotal, this.examPageSize);
  }

  // Top pager: shown for any non-empty result set, so the count is always visible.
  get showPatientPager(): boolean {
    return !!this.patList && this.patList.length > 0 && !this.isAWL;
  }

  // Bottom pager: only worth repeating when the page is full and there is somewhere else to go.
  // A short last page leaves the top pager on screen already.
  get showBottomPatientPager(): boolean {
    return this.showPatientPager && this.patList.length >= this.pageSize && this.totalPages > 1;
  }

  get showExamPager(): boolean {
    return !!this.examList && this.examList.length > 0;
  }

  get showBottomExamPager(): boolean {
    return (
      this.showExamPager && this.examList.length >= this.examPageSize && this.examTotalPages > 1
    );
  }

  console = console;
  constructor(
    public gs: GastroService,
    public loginService: LoginService,
    public patservice: PatientsService,
    public exServ: ExamsService,
    private rt: Router,
    public gfs: GastroFormsService,
    private http: HttpClient,
    private sidebarService: PatientsSidebarService
  ) {
    this.loginService.loginMissing();
    this.id = '';
    this.first = '';
    this.last = '';
    this.phone = '';

    if (loginService.isGastro) {
      this.examNames = ['Gastroscopy', 'Colonoscopy', 'Sigmoidoscopy'];
      // this.AWLStatus ="All";
    }
    if (loginService.isCardio) {
      this.examNames = [
        'TTE Adults',
        'Stress-Echo',
        'Duplex Carotid',
        'ECG',
        'Ergometry',
        'Stress',
      ];
    }
    for (const e of this.examNames) this.examVals[e] = true;
  }

  onSearchRequested(data: SearchParams) {
    this.id = data.id;
    this.first = data.first;
    this.last = data.last;
    this.phone = data.phone;
    this.isReports = false;
    this.reportList = null;
    this.search(data.noawl);
  }

  onAwlRequested(data: { id: string; first: string; last: string; phone: string }) {
    this.id = data.id;
    this.first = data.first;
    this.last = data.last;
    this.phone = data.phone;
    this.isReports = false;
    this.AWL();
  }

  onAddPatientRequested(data: AddPatientParams) {
    // The number typed in the sidebar's search/new-patient field is a mobile number
    // (patients walking in without an appointment, typing their number to be found or
    // registered) — it must land in Mobile, not Phone, or the SMS-link fallback logic
    // (Mobile, then Phone) can end up texting the wrong field.
    this.selectedPatient = new Patient(data.id, data.first, data.last);
    this.selectedPatient.Mobile = data.phone;
    this.isReports = false;
  }

  // Show the Patients view on entry: drop the other views (so only its title shows) and cancel any in-flight fetch.
  private enterPatientSearchView(): void {
    this.searchSeq++;
    this.isAWL = false;
    this.AWLlist = null;
    this.examList = null;
    this.reportList = null;
    this.statisticsForDoctors = null;
    this.awlListLoading = false;
    this.examListLoading = false;
    this.patientSearchView = true;
    // Bumping searchSeq above makes any in-flight response bail out before it can clear the
    // button, so release it here or it stays disabled forever.
    this.sidebarService.searching$.next(false);
  }

  // Title shows while the Patients view is active or once a search has results.
  get showPatientsTitle(): boolean {
    return this.patientSearchView || !!this.patList;
  }

  onClearRequested() {
    this.id = '';
    this.first = '';
    this.last = '';
    this.phone = '';
    if (this.isAWL) this.search();
  }

  ngOnInit() {
    let now = new Date();
    const ndate =
      now.getFullYear() +
      '-' +
      (now.getMonth() + 1 < 10 ? '0' : '') +
      (now.getMonth() + 1) +
      '-' +
      (now.getDate() < 10 ? '0' : '') +
      now.getDate();
    now = new Date(ndate);
    this.tod = now;
    this.fromd = now;
    if (this.loginService.showAWL()) {
      if (this.loginService.lastAwl) {
        this.AWLStatus = this.loginService.lastAwl;
      }
      if (this.loginService.lastAwlExam) this.AWLExam = this.loginService.lastAwlExam;
      if (this.loginService.lastAwlStartDate && this.loginService.lastAwlEnDate) {
        this.startdate = this.loginService.lastAwlStartDate;
        this.enddate = this.loginService.lastAwlEnDate;
      }
      if (this.loginService.isCardio) {
        switch (this.loginService.userType) {
          case 'doctor':
            this.AWLStatus = 'Completed';

            break;
          case 'tech':
            this.AWLStatus = 'Received';

            break;

          default:
            this.AWLStatus = 'Waiting';
            break;
        }
      }
      if (!this.exServ.searchReport && this.sidebarService.pendingNavItem !== 'patient-search')
        this.AWL();
    }
    this.loginService.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (
        (this.goEx.preg && this.goEx.exam && this.goEx.etype) ||
        (this.goEx && (this.loginService.isGastro || this.loginService.isCardio))
      ) {
        this.exServ.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype);
      }
    });
    this.patservice.exitFromGastroExam.subscribe(() => {
      this.AWLStatus = this.patservice.AWLStatus;
      this.loginService.lastAwl = 'All';
    });
    this.patservice.awlIncomming.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.isAWL) this.AWL();
    });
    if (this.exServ.searchReport) {
      this.fromd = this.exServ.searchReport.start;
      this.tod = this.exServ.searchReport.end;
      this.reportName = this.exServ.searchReport.type;
      this.hmostype = this.exServ.searchReport.hmo;
      this.isReports = true;
      this.AWLlist = null;
      this.searchClosed([this.fromd, this.tod, [], this.reportName, this.hmostype]);
      // this.examSearch(this.reportName, this.hmostype);
    }

    this.patservice.getZimunfeedID();

    if (!this.loginService.ishospital && this.loginService.premissions?.Consent) {
      this.exServ.getAllPractitioners().subscribe((data: any) => {
        this.clinicPractitioners = data;
        if (this.clinicPractitioners.length < 2) {
          const selectedPractitioner = this.clinicPractitioners[0];
          this.exServ.consentPractitioner =
            selectedPractitioner?.Title + ' ' + selectedPractitioner?.Name;
          this.setConsentDocUID();
        }
      });
    }

    // ── Subscribe to app-level sidebar events ──────────────────
    this.sidebarService.search$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => this.onSearchRequested(data));
    this.sidebarService.awl$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => this.onAwlRequested(data));
    this.sidebarService.addPatient$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => this.onAddPatientRequested(data));
    this.sidebarService.openEsearch$.pipe(takeUntil(this.destroy$)).subscribe((isReports) => {
      this.openEsearch = true;
      this.isReports = isReports;
    });
    this.sidebarService.clear$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.onClearRequested());
    this.sidebarService.showHelp$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => (this.showhelp = true));
    this.sidebarService.activeNavChange$.pipe(takeUntil(this.destroy$)).subscribe((view) => {
      this.activeView = view;
      if (view === 'patient-search') {
        this.enterPatientSearchView();
      } else {
        this.patientSearchView = false;
      }
    });
    // Push initial isAWL state so the sidebar reflects current state on first load
    this.sidebarService.isAWL$.next(this.isAWL);

    // Consume pending open-search request (e.g. user clicked Search Exams / Reports from /dashboard)
    if (this.sidebarService.pendingOpenEsearch !== null) {
      this.openEsearch = true;
      this.isReports = this.sidebarService.pendingOpenEsearch;
      this.sidebarService.pendingOpenEsearch = null;
    }

    // Consume a search/today's-list/new-patient triggered from the legacy sidebar off /patsearch (e.g. /dashboard).
    if (this.sidebarService.pendingSearch) {
      this.onSearchRequested(this.sidebarService.pendingSearch);
      this.sidebarService.pendingSearch = null;
    }
    if (this.sidebarService.pendingAwl) {
      this.onAwlRequested(this.sidebarService.pendingAwl);
      this.sidebarService.pendingAwl = null;
    }
    if (this.sidebarService.pendingAddPatient) {
      this.onAddPatientRequested(this.sidebarService.pendingAddPatient);
      this.sidebarService.pendingAddPatient = null;
    }
  }

  onClosed(closed: string) {
    if (closed) this.selectedPatient = null;
    if (closed == 'awl') {
      this.id = '';
      this.first = '';
      this.last = '';
      this.phone = '';
      this.AWL();
    } else if (this.patList) this.search(); //to refresh details
    this.awlExamType = null;
    this.awlLMP = null;
    this.awlTime = null;
    this.chosenAWL = null;
    this.prn = null;
    this.code = null;
    this.typeForm = null;
    this.showIcons = false;
  }

  // Hides a list spinner after the fade-out has had time to play. Each list owns its own flag.
  // Also releases the sidebar's Search button, which stays disabled through the fade to absorb double-clicks.
  private hideListSpinner(list: 'awlList' | 'patList' | 'examList') {
    const loadingFlag = `${list}Loading` as const;
    const fadingFlag = `${list}Fading` as const;
    this[fadingFlag] = true;
    setTimeout(() => {
      this[loadingFlag] = false;
      this[fadingFlag] = false;
      // Release the button only once nothing else is still loading, so one list finishing
      // can't re-enable it while another request is still in flight.
      if (!this.awlListLoading && !this.patListLoading && !this.examListLoading) {
        this.sidebarService.searching$.next(false);
      }
    }, SPINNER_FADEOUT_DURATION);
  }

  search(noawl = false) {
    const seq = ++this.searchSeq;
    // Clear all spinners up front; the branch taken below turns its own back on.
    this.awlListLoading = false;
    this.patListLoading = false;
    this.examListLoading = false;
    this.sidebarService.searching$.next(true);
    this.examList = null;
    this.reportList = null;
    this.statisticsForDoctors = null;
    this.showIcons = false;
    this.exServ.searchReport = null;
    // Leaving report mode: without this a prior Leumit report keeps the template in report layout.
    this.isReports = false;
    this.carderror = null;
    // Resets to the first page on new search
    this.currentPage = 1;
    // Resets the pagination control buttons
    this.showPaginationControls = false;

    if (this.isAWL && !noawl) {
      this.patientSearchView = false;
      this.patList = null;
      // Clear the stale list so only the spinner shows while reloading.
      this.AWLlist = null;
      this.awlListLoading = true;
      if ((this.startdate, this.enddate)) {
        var start =
          this.startdate._i.year +
          '-' +
          (this.startdate._i.month + 1) +
          '-' +
          this.startdate._i.date +
          ' 00:00:00.000';
        var end =
          this.enddate._i.year +
          '-' +
          (this.enddate._i.month + 1) +
          '-' +
          this.enddate._i.date +
          ' 23:59:59.000';
      }
      this.patservice
        .getAWL(this.AWLStatus, this.AWLExam, {
          id: this.id,
          first: this.first,
          last: this.last,
          start: start,
          end: end,
          uid: this.loginService.doctor,
        })
        .subscribe(
          (patients: Patient[]) => {
            // Drop the response if a newer search (e.g. a switch to Today's List) has started.
            if (seq !== this.searchSeq) {
              return;
            }
            // Delay hiding the spinner so its fade-out has time to play.
            this.hideListSpinner('awlList');
            if (patients.length > 0) {
              this.GaArray = [];
              patients.forEach((i) => {
                const GAitem = this.lmpGA(i.ExamLMP);
                this.GaArray.push(GAitem);
                if (i.UID) i['nUID'] = i.UID;
              });
            }
            this.AWLlist = patients;
            this.loadConsentStatuses(patients);
            this.loadQuestionnaireStatuses(patients);
            if (this.cardtzsearch) {
              this.swiping = false;
              for (const pat of this.AWLlist) {
                let zeros = pat.ID;
                while (zeros.length < 9) zeros = '0' + zeros;
                if (pat.ID == this.cardtzsearch || zeros == this.cardtzsearch) {
                  this.setAWL(pat);
                  this.selectedPatient = pat;
                  if (this.selectedPatient.HMO != 'Macabi') {
                    //now for macabi only
                    this.selectedPatient.HMO = 'Macabi';
                    this.patservice
                      .savePatient(this.selectedPatient, this.selectedPatient.PID)
                      .subscribe(
                        (data) => {},
                        (error) => {
                          console.log(error);
                        }
                      );
                  }
                  this.showpayment = this.cardtzsearch;
                  this.cardtzsearch = null;
                }
              }
              if (this.cardtzsearch) {
                this.carderror = this.cardtzsearch;
                this.cardtzsearch = null;
              }
            }
          },
          (error) => {
            console.log(error);
            this.hideListSpinner('awlList');
          }
        );
    } else {
      this.patientSearchView = true;
      this.AWLlist = null;
      // Clear the stale list so only the spinner shows while reloading.
      this.patList = null;
      this.patListLoading = true;
      // this.visitPat = null;
      this.patservice.getPatients(
        this.id,
        this.first,
        this.last,
        this.phone,
        this.loginService.doctor,
        (patients: Patient[]) => {
          // Drop the response if a newer search (e.g. a switch to Today's List) has started.
          if (seq !== this.searchSeq) {
            return;
          }
          // Delay hiding the spinner so its fade-out has time to play.
          this.hideListSpinner('patList');
          this.patList = [];
          this.isAWL = false;
          for (let i = 0; i < patients.length; i++) {
            const pat = new Patient();
            pat.asignVals(patients[i]);
            this.patList[i] = pat;
          }
          this.totalResults = resolveTotal(patients as any);
          this.showPaginationControls = shouldShowControls(this.totalResults, this.pageSize);
        },
        this.currentPage,
        this.pageSize,
        () => this.hideListSpinner('patList')
      );
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadPatients();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadPatients();
    }
  }

  loadPatients() {
    const seq = ++this.searchSeq;
    this.patListLoading = true;
    this.sidebarService.searching$.next(true);
    this.patservice.getPatients(
      this.id,
      this.first,
      this.last,
      this.phone,
      this.loginService.doctor,
      (patients: Patient[]) => {
        // Drop the response if a newer search has superseded this page load.
        if (seq !== this.searchSeq) {
          return;
        }
        this.patList = [];
        for (let i = 0; i < patients.length; i++) {
          const pat = new Patient();
          pat.asignVals(patients[i]);
          this.patList[i] = pat;
        }
        this.totalResults = resolveTotal(patients as any);
        this.showPaginationControls = shouldShowControls(this.totalResults, this.pageSize);
        this.hideListSpinner('patList');
      },
      this.currentPage,
      this.pageSize,
      () => this.hideListSpinner('patList')
    );
  }

  AWL(savestatus = true, type = null) {
    if (!this.enddate && this.startdate) {
      this.enddate = this.startdate;
    } else if (!this.startdate && this.enddate) {
      this.startdate = this.enddate;
    }
    if (savestatus) {
      this.loginService.lastAwlExam = this.AWLExam;
      this.loginService.lastAwl = this.AWLStatus;
      this.loginService.lastAwlStartDate = this.startdate;
      this.loginService.lastAwlEnDate = this.enddate;
    }
    this.isAWL = true;
    this.sidebarService.isAWL$.next(true);
    this.examList = null;
    this.reportList = null;
    this.statisticsForDoctors = null;
    this.exServ.searchReport = null;
    this.search();
    this.patservice.openWebSocket(
      !this.loginService.ishospital ? this.loginService.ClinicID : null
    );
  }

  switchSearch() {
    this.patientsearch = !this.patientsearch;
    if (!this.patientsearch) this.examSearch();
    else this.examList = [];
    this.reportList = [];
    this.statisticsForDoctors = [];
  }

  examSearch(reportInfo = []) {
    const [format, filter, from, until, reportName] = reportInfo;
    this.reportType = reportName;
    this.isAWL = false;
    this.patientSearchView = false;
    this.AWLlist = null;
    this.visitPat = null;
    this.patList = null;
    // Leaving the AWL/patient views — clear their spinners.
    this.awlListLoading = false;
    this.patListLoading = false;
    if (reportInfo.length) {
      this.isReports = true;
      this.reportName = reportName;
      this.hmostype = 'Leumit';
      this.exServ.searchReport = { start: from, end: until, type: reportName, hmo: 'Leumit' };
      this.exServ
        .reportSearch(format, filter, from, until, this.loginService.doctor)
        .subscribe((data) => {
          if (filter === 'missing') {
            this.withoutPrn = true;
          }
          if (filter === 'sent') {
            this.withoutPrn = false;
          }
          this.examList = null;
          if (format === 'statistics') {
            this.statisticsForDoctors = data;
            this.reportList = null;
            this.showIcons = true;
            this.examTypeCounts = {};
            return;
          }
          this.reportList = data;
          if (this.reportList.length > 0) {
            this.countExamTypes();
            this.showIcons = true;
            this.statisticsForDoctors = null;
          } else {
            this.showIcons = false;
            this.examTypeCounts = {};
            this.reportList = [];
            this.statisticsForDoctors = [];
          }
        });
    } else {
      this.exServ.searchReport = null;
      // Explicit reset: this is the plain exam-search branch, never a report.
      this.isReports = false;
      // Clear the stale list so only the spinner shows while reloading.
      this.examList = null;
      this.examListLoading = true;
      this.exServ
        .examSearch(
          this.fromd,
          this.tod,
          this.examVals,
          this.loginService.doctor,
          this.examPage,
          this.examPageSize
        )
        .subscribe(
          (data) => {
            // Delay hiding the spinner so its fade-out has time to play.
            this.hideListSpinner('examList');
            this.examList = data;
            this.examTotal = resolveTotal(data as any);
            this.showExamControls = shouldShowControls(this.examTotal, this.examPageSize);
            this.reportList = null;
            this.showIcons = false;
            this.statisticsForDoctors = null;
            this.examTypeCounts = {};
          },
          (error) => {
            console.log(error);
            this.hideListSpinner('examList');
          }
        );
    }
  }

  nextExamPage() {
    if (this.examPage < this.examTotalPages) {
      this.examPage++;
      this.examSearch();
    }
  }

  previousExamPage() {
    if (this.examPage > 1) {
      this.examPage--;
      this.examSearch();
    }
  }

  countExamTypes() {
    for (const exam of this.reportList) {
      if (exam.ExamType in this.examTypeCounts) {
        this.examTypeCounts[exam.ExamType]++;
      } else {
        this.examTypeCounts[exam.ExamType] = 1;
      }
    }
    return this.examTypeCounts;
  }

  goPatient(pid: number) {
    this.patservice.getPatient(pid, (s) => {
      if (s) this.rt.navigate(['/exams'], { state: { data: this.patservice.currentPatient } });
    });
  }

  getLocked(exam) {
    const now = new Date();
    const lockedTime = new Date(exam.Locked);
    let lock = true;
    if (
      now.getDate() != lockedTime.getDate() ||
      now.getMonth() != lockedTime.getMonth() ||
      now.getFullYear() != lockedTime.getFullYear() ||
      now.getHours() - lockedTime.getHours() > 1
    ) {
      lock = false;
    }
    if ((exam.Locked || lock) && exam.LockedBy && !this.loginService.isAdmin) return 'locked';
    return 'unlocked';
  }

  viewonly() {
    this.exServ.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype, true);
  }

  goExam(exam /*PID: number, examID: number, PregIndex: number, etype: string,examtime: string*/) {
    const preg = exam.PregIndex ? { AutoIndex: exam.PregIndex } : null;
    const id = exam.AutoIndex;
    this.patservice.getPatient(exam.PID, (s) => {
      if (s) {
        if (exam.Locked && exam.LockedBy && !this.loginService.isAdmin) return;
        const etime = new Date(exam.CreationTime);
        const now = new Date();
        if (
          exam.ExamType != 'Emergency Room' &&
          ((!this.exServ.examClosed(etime) && !this.loginService.isCardio) ||
            (this.loginService.isCardio && !exam.ClosedDate)) &&
          (this.loginService.userType == 'doctor' ||
            this.loginService.userType == 'visitingdoc' ||
            this.loginService.userType == 'tech')
        ) {
          this.showLogin = true;

          this.goEx = { preg: preg, exam: exam, etype: exam.ExamType };
          if (this.loginService.ClinicID) this.startClinic = this.loginService.ClinicID;
        } else this.exServ.goExam(preg, exam, exam.ExamType, s.PID);
      }
    });
  }
  // ************************************************************************************************
  searchClosed($event: any[]) {
    this.examTypeCounts = {};

    if ($event && $event.length >= 3 && $event[2] == 'Travel Report') {
      const fromd = new Date($event[0]);
      fromd.setHours(fromd.getHours() + 5);
      const froms = fromd.toISOString().slice(0, 10);
      const untild = new Date($event[1]);
      untild.setHours(untild.getHours() + 29);
      const untils = untild.toISOString().slice(0, 10);
      window.open('/api/stats/travelreport/' + froms + '/' + untils);
      return;
    }

    if (!$event) {
      this.openEsearch = false;
    } else {
      if (this.reportsNames.includes($event[4])) {
        this.examSearch($event);
      } else if ($event && $event.length > 3) {
        this.fromd = $event[0];
        this.tod = $event[1];
        this.examVals = $event[2];
        this.examMode = $event[3];
        // A fresh set of criteria always starts at page 1, never wherever the last search left off.
        this.examPage = 1;
        this.examSearch();
      }
    }
    this.showIcons = true;
    this.openEsearch = false;
  }

  setAWL(pat) {
    if (
      (!this.loginService.ishospital || this.loginService.ishospital == 'belinson') &&
      pat.Status == 'Waiting'
    ) {
      try {
        const edate = new Date(pat.ExamDate);
        this.awlTime =
          edate.getHours() + ':' + (edate.getMinutes() < 10 ? '0' : '') + edate.getMinutes();
      } catch {
        this.awlTime = null;
      }
      this.awlExamType = pat.ExamCode;

      this.awlLMP = pat.ExamLMP;
      this.awlComment = pat.Reason ? pat.Reason : null;
    }
    this.chosenAWL = pat.AWLID;
  }
  lmpGA(lmp) {
    if (!lmp) return '';
    const dt = new Date();
    const days = Math.floor((dt.getTime() - Date.parse(lmp)) / (1000 * 60 * 60 * 24));
    return Math.floor(days / 7) + 'w ' + (Math.floor(days) % 7) + 'd';
  }

  saveComment(comment: string, AWLID: number) {
    this.patservice.saveAWLComment(comment, AWLID);
  }

  getcard() {
    this.card = '';
    setTimeout(() => {
      this.swipeField.nativeElement.focus();
    }, 100);
  }

  proccesscard(evt) {
    evt = evt || window.event;
    let isEscape = false;
    if ('key' in evt) isEscape = evt.key === 'Escape' || evt.key === 'Esc';
    else isEscape = evt.keyCode === 27;

    if (isEscape) this.swiping = false;
    let card = this.card;
    if (this.card && this.card.length > 26 && this.card.includes('8=47'))
      //8=47 is the start of a macabi card
      card = this.card.substring(this.card.indexOf('8=47'));
    if (card && card.length > 26 && !this.cardtzsearch && !this.showpayment) {
      this.cardtzsearch = card.substring(7, 16);
      this.idcode = card.substring(6, 7);
      this.expcode = card.substring(16, 20);
      if (this.AWLStatus != 'All') this.AWLStatus = 'All';
      this.AWL(false);
    }
  }

  barscan(evt) {
    evt = evt || window.event;
    let isEscape = false;
    if ('key' in evt) isEscape = evt.key === 'Escape' || evt.key === 'Esc';
    else isEscape = evt.keyCode === 27;

    if (isEscape) this.swiping = false;

    if (
      this.card.trim().length >= 12 &&
      (!this.last_search_time || Date.now() > this.last_search_time + 5000)
    ) {
      //belinson addmission code
      this.last_search_time = Date.now();
      this.patservice.findPatBelinson(this.card.trim()).subscribe(
        (patient: Patient) => {
          if (patient) {
            this.patList = [];
            this.isAWL = false;
            const pat = new Patient();
            pat.asignVals(patient);
            this.patList[0] = pat;
            this.setAWL(pat);
            this.selectedPatient = pat;
            this.swiping = false;
            this.card = '';
            this.awlTime = new Date().toTimeString().substring(0, 5);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  paymentNoCard() {
    this.showpayment = this.selectedPatient.ID;
    while (this.showpayment.length < 9) this.showpayment = '0' + this.showpayment.toString();
    this.idcode = '0';
    this.expcode = null;
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.sub.unsubscribe();
    this.patservice.closeWebSocket();
    this.patservice.closeConsentSocket();
    this.signatureSubscription.unsubscribe();
  }

  getStatus(status: string): string {
    //for cardio
    if (this.loginService.isCardio) {
      switch (status) {
        case 'Completed':
          return 'Performed';
        case 'Waiting':
          return 'Scheduled';
        case 'Received':
          return 'Waiting';
        default:
          return status;
      }
    } else return status;
  }

  setExamCode(pat) {
    const saveTitle = this.patservice.setExamCode(this.changedExamCode, pat.AWLID);
    saveTitle.subscribe((res) => {
      console.log(res);
      this.changedExamCode = null;
      this.AWL();
    });
  }

  setPatAwlid(pat) {
    if (this.loginService.isGastro) {
      this.gfs.paitentLoaded$.next(pat);
    }
  }

  filterExams(exams, type, hmo = null) {
    if (!exams) return [];
    if (hmo) return exams.filter((i) => i.ExamType == type && i.HMO == hmo && i.PRN);
    return exams.filter((i) => i.ExamType == type);
  }

  export() {
    let table;
    let strTable;
    const items = ['CreationTime', 'ID', 'First', 'Last', 'HMO', 'ExamType'];
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    strTable = '<tr>';
    strTable +=
      '<td> חיפוש לפי</td><td>' +
      this.getType(this.exServ.searchReport.type) +
      '</td><td>' +
      this.getHMO(this.exServ.searchReport.hmo) +
      '</td>';
    strTable += '</tr><tr></tr>';
    strTable +=
      '<tr><td>תאריכים</td><td>' +
      this.getDate(this.exServ.searchReport.start) +
      '</td><td>' +
      this.getDate(this.exServ.searchReport.end) +
      '</td></tr>';

    if (this.examList.length > 0) {
      for (const name of this.examNames) {
        let examTable = '';
        examTable += '<tr>';
        table = document.createElement('table');
        examTable += `<td>${name}</td>`;
        examTable += '</tr>';
        examTable += '<tr>';
        for (const item of items) {
          examTable += `<td><strong>${item}</strong></td>`;
        }
        examTable += '</tr>';
        examTable += '<tr>';
        for (const exam of this.filterExams(this.examList, name)) {
          for (const item of items) {
            var date;
            if (item == 'CreationTime') {
              date = exam[item].replace('T', ' ').replace('Z', '');

              examTable += `<td>${date}</td>`;
            } else {
              examTable += `<td>${exam[item]}</td>`;
            }
          }
          examTable += '</tr>';
        }
        table.innerHTML = strTable + examTable;
        if (this.filterExams(this.examList, name).length > 0) {
          const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
          XLSX.utils.book_append_sheet(wb, ws, name);
        }
      }
      XLSX.writeFile(wb, new Date().toISOString().split('T')[0] + '.xlsx');
      this.loginService.exportLoading = false;
      this.showLogin = false;
      this.sub.unsubscribe();
    }
  }

  sendMacabi() {
    this.patservice
      .sendMacabi(
        this.fromd['_i'].year +
          '-' +
          (this.fromd['_i'].month + 1 < 10 ? '0' : '') +
          (this.fromd['_i'].month + 1) +
          '-' +
          (this.fromd['_i'].date < 0 ? '0' : '') +
          this.fromd['_i'].date,
        this.tod['_i'].year +
          '-' +
          (this.tod['_i'].month + 1 < 10 ? '0' : '') +
          (this.tod['_i'].month + 1) +
          '-' +
          (this.tod['_i'].date < 0 ? '0' : '') +
          this.tod['_i'].date
      )
      .subscribe(
        (data) => {
          this.sentMacabi = true;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getHMO(hmo) {
    switch (hmo) {
      case 'Macabi':
        return 'מכבי';
      case 'Leumit':
        return 'לאומית';
      case 'Meuhedet':
        return 'מאוחדת';
      case 'Clalit':
        return 'כללית';
      case 'Private':
        return 'פרטי';
      case 'IDF':
        return 'צהל';
      case 'null':
        return 'לא שוייכו';
      default:
        return 'הכל';
    }
  }
  getType(type) {
    switch (type) {
      case 'Macabi':
        return 'בדיקות שנשלחו למכבי';
      case 'HMO':
        return 'קופת חולים';
      case 'Refferelnum':
        return "מס' הפניה חסר";
      default:
        return 'הכל';
    }
  }
  getDate(date) {
    const temp = new Date(date);
    const str = temp.getDate() + '/' + (temp.getMonth() + 1) + '/' + temp.getFullYear();
    return str;
  }

  startForm(pat) {
    this.exServ.patServ.setPat(pat);
    this.exServ.concentForm = null;
    const res = this.exServ.getConcentForms(pat.PID);
    const examType = this.exServ.consentExamType || pat.ExamCode;
    res.subscribe((data: any) => {
      const existingConsent = this.findExistingConsent(data, examType);
      if (existingConsent) {
        this.exServ.consentExamType = examType;
        this.setConsentDocUID();
        if (examType === 'Gynecology') {
          this.exServ.openNewExam = false;
          this.exServ.loadPrevDocSign = true;
          this.concentForm = existingConsent;
          this.selectedGynConsentType = existingConsent.GynConsentType || '';
          this.startConsentSocket(pat);
          this.showGynConsent = true;
        } else {
          this.concentForm = existingConsent;
          this.startConsentSocket(pat);
          this.inform = true;
        }
        return;
      }
      this.exServ.concentForm = null;
      this.exServ.examID = null;
      this.exServ.pregId = null;
      this.concentForm = null;
      this.checkPastTermThenOpen(pat);
    });
  }

  // Only an unlinked consent of the same type counts — Anatomy/Trimester codes match on prefix.
  private findExistingConsent(forms: any, examType: string) {
    if (!forms || forms.hasOwnProperty('empty')) {
      return null;
    }
    const examSuffix = examType?.split(' ')[1];
    const matchType =
      examSuffix == 'Anatomy' || examSuffix == 'Trimester' ? examType.split(' ')[0] : examType;
    return this.exServ.usableConsents(forms, matchType)[0] || null;
  }

  // The worklist bypasses patexams, so the past-term guard has to run here as well.
  private checkPastTermThenOpen(pat) {
    this.exServ.getExams(pat.PID.toString()).subscribe({
      next: (data: any) => {
        this.exServ.pregnancies = data['pregnancies'];
        const pastTermPregs = this.exServ.pastTermOpenPregnancies(this.exServ.pregnancies);
        if (pastTermPregs.length > 0) {
          const pregIDs = pastTermPregs.map((preg) => preg.AutoIndex);
          this.exServ.offerPastTermClose(pregIDs, () => {
            // patch the records we hold so the retry cannot loop on a stale list
            pastTermPregs.forEach((preg) => (preg.ClosedDate = new Date()));
            this.startForm(pat);
          });
          return;
        } else {
          this.exServ.examID = null;
          this.exServ.pregId = null;
          this.exServ.pregnancies = null;
          this.exServ.concentForm = null;
          this.concentForm = null;
        }
        this.startConsentSocket(pat);
        this.inform = true;
      },
    });
  }

  openSendQuestionnaire(pat: any) {
    this.sendQuestionnairePatient = pat;
    this.showSendQuestionnaire = true;
  }

  openConsentModal(pat) {
    this.exServ.patServ.setPat(pat);
    this.exServ.concentForm = null;
    this.consentModalPat = pat;
    const examCodeMap: { [key: string]: string } = {
      '1st Trimester': '1st',
      'Early Anatomy': 'Early',
      '2nd/3rd Trimester': '2nd/3rd',
      'Late Anatomy': 'Late',
    };
    // Use AppointmentExamType (from examsSettings via appointment) if available, fallback to ExamCode
    const rawCode = pat.AppointmentExamType || pat.ExamCode;
    const resolvedExamCode = examCodeMap[rawCode] || rawCode;
    this.exServ.getConcentForms(pat.PID).subscribe((data: any) => {
      if (!data.hasOwnProperty('empty')) {
        const examCode = resolvedExamCode;
        // only a consent no exam owns yet — type alone reopened forms from past exams
        const existingForm = this.exServ.usableConsents(data, examCode)[0] || null;
        if (existingForm) {
          this.exServ.consentExamType = examCode;
          this.setConsentDocUID();
          if (examCode === 'Gynecology') {
            this.exServ.openNewExam = false;
            this.exServ.loadPrevDocSign = true;
            this.concentForm = existingForm;
            this.selectedGynConsentType = existingForm.GynConsentType || '';
            this.startConsentSocket(pat);
            this.showGynConsent = true;
          } else {
            this.concentForm = existingForm;
            this.startConsentSocket(pat);
            this.inform = true;
          }
          return;
        }
      }
      // No existing form — show modal
      const openModal = () => {
        this.consentModalPat = pat;
        const examCodeMap2: { [key: string]: string } = {
          '1st Trimester': '1st',
          'Early Anatomy': 'Early',
          '2nd/3rd Trimester': '2nd/3rd',
          'Late Anatomy': 'Late',
        };
        const consentExamTypes = [
          '1st',
          'NT',
          'Early',
          '2nd/3rd',
          'Weight Assessment',
          'Late',
          'Third Scan',
          'Specialized',
          'Fetal Echo',
          'Gynecology',
        ];
        // 1. If has appointmentId — use AppointmentExamType
        if (pat.appointmentId) {
          const rawCode2 = pat.AppointmentExamType || pat.ExamCode;
          const mappedCode = examCodeMap2[rawCode2] || rawCode2;
          this.consentExamType = consentExamTypes.includes(mappedCode) ? mappedCode : '';
        } else {
          // 2. If ExamCode matches one of our consent types — use it
          const rawCode2 = pat.ExamCode;
          const mappedCode = examCodeMap2[rawCode2] || rawCode2;
          this.consentExamType = consentExamTypes.includes(mappedCode) ? mappedCode : '';
          // 3. If no match — stays empty, user picks in modal
        }
        this.selectedGynConsentType = '';
        this.consentPractitionerObj = null;
        if (this.loginService.userType !== 'doctor' && this.clinicPractitioners?.length > 0) {
          if (this.clinicPractitioners.length === 1) {
            // Single practitioner — always auto-set
            this.consentPractitionerObj = this.clinicPractitioners[0];
          } else if (this.loginService.separatedClinic) {
            // Separated clinic — find by patient UID like patexam does
            this.consentPractitionerObj =
              this.clinicPractitioners.find((p) => p.UID == pat.UID) || null;
          } else if (pat.appointmentId) {
            // Multi non-separated + came from appointment — find by DocUID from appointments table
            this.consentPractitionerObj =
              this.clinicPractitioners.find((p) => p.UID === pat.AppointmentDocUID) || null;
          }
          // else: multi non-separated, no appointment — leave null, user picks manually
          if (this.consentPractitionerObj) {
            this.exServ.consentPractitioner =
              this.consentPractitionerObj.Title + ' ' + this.consentPractitionerObj.Name;
          }
        }
        this.showConsentModal = true;
      };

      const needsPractitioners =
        !this.loginService.ishospital &&
        this.loginService.premissions?.Consent &&
        this.loginService.userType !== 'doctor' &&
        this.clinicPractitioners.length === 0;

      if (needsPractitioners) {
        this.exServ.getAllPractitioners().subscribe((practitioners: any) => {
          this.clinicPractitioners = practitioners;
          if (this.clinicPractitioners.length < 2) {
            const sp = this.clinicPractitioners[0];
            this.exServ.consentPractitioner = sp?.Title + ' ' + sp?.Name;
            this.setConsentDocUID();
          }
          openModal();
        });
      } else {
        openModal();
      }
    });
  }

  confirmConsentModal() {
    if (!this.consentExamType) return;
    this.showConsentModal = false;
    this.exServ.consentExamType = this.consentExamType;
    if (this.consentPractitionerObj) {
      this.exServ.consentPractitioner =
        this.consentPractitionerObj.Title + ' ' + this.consentPractitionerObj.Name;
    }
    this.setConsentDocUID();
    if (this.consentExamType === 'Gynecology') {
      this.exServ.patServ.setPat(this.consentModalPat);
      this.exServ.concentForm = null;
      this.exServ.openNewExam = false;
      this.exServ.loadPrevDocSign = true;
      this.concentForm = null;
      this.startConsentSocket(this.consentModalPat);
      this.showGynConsent = true;
    } else {
      this.startForm(this.consentModalPat);
    }
  }

  setConsentDocUID() {
    let selectedDoc: any;
    if (this.loginService.userType === 'doctor') {
      selectedDoc = this.loginService;
    } else {
      selectedDoc = this.clinicPractitioners.find(
        (user) => user?.Title + ' ' + user?.Name === this.exServ.consentPractitioner
      );
    }
    this.exServ.consentDocUID = selectedDoc?.UID;
  }

  closeGynConsent(event) {
    this.finishConsentForm(this.consentModalPat);
    this.showGynConsent = false;
    this.selectedGynConsentType = '';
  }

  private startConsentSocket(pat: any) {
    this.patservice.openConsentSocket();
    this.signatureSubscription.unsubscribe();
    this.signatureSubscription = this.patservice.signatureIncoming.subscribe(() => {
      if (!pat?.PID) return;
      this.exServ.getConcentForms(pat.PID).subscribe((data: any) => {
        if (data?.hasOwnProperty('empty')) return;
        const examType = this.exServ.consentExamType;
        const form =
          examType === 'Gynecology'
            ? data.find((i: any) => i.ExamType === 'Gynecology')
            : data.find((i: any) => i.ExamType === examType);
        if (form && this.checkApprovedConcent(form)) {
          if (pat?.AWLID) this.patConsentSigned[pat.AWLID] = true;
          this.patservice.closeConsentSocket();
          this.signatureSubscription.unsubscribe();
          this.inform = false;
          this.showGynConsent = false;
          this.selectedGynConsentType = '';
        }
      });
    });
  }

  private finishConsentForm(pat: any) {
    // the singleton outlives this patient, so drop it here as the patexams handler does
    this.exServ.concentForm = null;
    if (!pat?.PID) {
      this.patservice.closeConsentSocket();
      this.signatureSubscription.unsubscribe();
      return;
    }
    const examType = this.exServ.consentExamType;
    this.exServ.getConcentForms(pat.PID).subscribe((data: any) => {
      if (!data?.hasOwnProperty('empty')) {
        const form =
          examType === 'Gynecology'
            ? data.find((i: any) => i.ExamType === 'Gynecology')
            : data.find((i: any) => i.ExamType === examType);
        if (form && this.checkApprovedConcent(form) && pat?.AWLID) {
          this.patConsentSigned[pat.AWLID] = true;
        }
      }
      this.patservice.closeConsentSocket();
      this.signatureSubscription.unsubscribe();
    });
  }

  private loadConsentStatuses(patients: any[]): void {
    if (!this.loginService.premissions?.Consent) return;
    this.patConsentSigned = {};
    const examCodeMap: { [key: string]: string } = {
      '1st Trimester': '1st',
      'Early Anatomy': 'Early',
      '2nd/3rd Trimester': '2nd/3rd',
      'Late Anatomy': 'Late',
    };
    const today = new Date();
    const isToday = (dateStr: string) => {
      if (!dateStr) return false;
      const d = new Date(dateStr);
      return (
        d.getFullYear() === today.getFullYear() &&
        d.getMonth() === today.getMonth() &&
        d.getDate() === today.getDate()
      );
    };
    for (const pat of patients) {
      if (!pat?.PID || !pat?.AWLID) continue;
      const rawCode = pat.AppointmentExamType || pat.ExamCode;
      if (!rawCode) continue;
      const examType = examCodeMap[rawCode] || rawCode;
      this.exServ.getConcentForms(pat.PID).subscribe((data: any) => {
        if (!Array.isArray(data)) return;
        let form: any;
        if (examType === 'Gynecology') {
          form = data.find(
            (i: any) =>
              i.ExamType === 'Gynecology' &&
              isToday(i.CreationTime) &&
              (!pat.UID || i.UID == pat.UID)
          );
        } else {
          const baseType =
            examType.split(' ')[1] === 'Anatomy' || examType.split(' ')[1] === 'Trimester'
              ? examType.split(' ')[0]
              : examType;
          form = data.find(
            (i: any) =>
              i.ExamType === baseType && isToday(i.CreationTime) && (!pat.UID || i.UID == pat.UID)
          );
        }
        if (form && this.checkApprovedConcent(form)) {
          this.patConsentSigned[pat.AWLID] = true;
        }
      });
    }
  }

  // AR-24: mark rows whose questionnaire has been answered, for the green ✓
  // badge on the today-list questionnaire icon (mirrors loadConsentStatuses).
  private loadQuestionnaireStatuses(patients: any[]): void {
    if (!this.loginService.premissions?.Questionnaires) return;
    this.patQuestionnaireAnswered = {};
    for (const pat of patients) {
      if (!pat?.PID || !pat?.AWLID) continue;
      this.exServ.getPatientQuestionnaires(pat.PID).subscribe((data: any) => {
        const items = (data && data.items) || [];
        const answered = items.some(
          (i: any) => i.answeredDate && (!pat.ExamCode || i.examCode === pat.ExamCode)
        );
        if (answered) this.patQuestionnaireAnswered[pat.AWLID] = true;
      });
    }
  }

  checkApprovedConcent(consent: any): boolean {
    if (
      consent.approved &&
      consent.approved !== 'appotropus' &&
      consent.patSign &&
      consent.patSignApproved &&
      consent.docSign
    )
      return true;
    if (consent.approved && consent.approved === 'appotropus' && consent.patSign && consent.docSign)
      return true;
    return false;
  }

  getDoctors() {
    return this.loginService.clinicUsers;
  }

  /*reassign(){//move pat and todaylist to another doctor
    this.toreassign.UID = this.toreassign.nUID;
    this.toreassign.nUid = this.toreassign.UID;
    this.patservice.reassign(this.toreassign).subscribe((data)=>{
      this.toreassign = null;
      this.AWL();
    },(error)=>{
      this.toreassign = null;
      this.AWL();
      console.log(error)
    })
  } */ //geting rid of this

  closCalForm(event) {
    this.finishConsentForm(this.consentModalPat);
    this.inform = false;
  }

  getDbName(i, str) {
    const t = i.replace('-', '').split(' ')[0];

    return str + t;
  }

  exportExcel() {
    if (this.reportList?.length > 0) {
      return this.exportExcelExams();
    }
    if (this.statisticsForDoctors?.length > 0) {
      return this.exportExcelStatistics();
    }
    return;
  }

  private exportExcelStatistics() {
    const statisticForLeumit = this.statisticsForDoctors.map((doctorStatistic) => {
      return {
        'Leumit with PRN': doctorStatistic.leumitWithoutPrn,
        'Leumit without PRN': doctorStatistic.leumitWithPrn,
        'Leumit Total': doctorStatistic.totalExamsForLeumit,
        'By other HMO’s': doctorStatistic.otherHmo,
        'No HMO indication': doctorStatistic.notRecognizeHmo,
        'Total exams performed': doctorStatistic.totalExams,
        Doctor: doctorStatistic.englishName,
      };
    });
    const sheetName = 'statisticForLeumitDoctor';
    const dateEnd = this.statisticsForDoctors[0].until.substring(0, 10);
    const fileName = `Exams Distribution by HMO’s for the period starting on  ${this.statisticsForDoctors[0].from}  and ending on  ${dateEnd}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(statisticForLeumit);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, fileName);
  }

  private exportExcelExams() {
    const examsToExport = this.reportList.map((exam) => {
      const CreationTime = exam.CreationTime.substring(0, 10);

      return {
        ExamType: exam.ExamType,
        Name: `${exam.First} ${exam.Last} `,
        CreationTime,
        patientId: exam.ID,
        Doctor: exam.Name,
      };
    });
    const sheetName = 'Exams';
    const fileName = `${this.reportType}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(examsToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, fileName);
  }

  genaratePdf() {}

  getPDF() {}

  redirectAdministration(type) {
    this.http.post('/api/administration', { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }

  isSearchDisabled(): boolean {
    return !(this.id.trim() || this.first.trim() || this.last.trim() || this.phone.trim());
  }
}
